import { jsx as r } from "react/jsx-runtime";
import { TextPrimitive as e } from "./index.es761.js";
import { forwardRef as i } from "react";
const p = i((t, o) => /* @__PURE__ */ r(e, { ...t, type: "button", role: "button-text", variant: "semi-bold", ref: o }));
export {
  p as ButtonText
};
//# sourceMappingURL=index.es488.js.map
